export default __webpack_public_path__ + "static/bsc-b1805ef24a69a0a76db3cfd8e559cf82.png";